/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*トップページ Category List*/
  $('.CategoryList__Filter--Item').on('click', function() {
    $('.CategoryList__Filter--Item').removeClass("CategoryList__Filter--current");
    $(this).addClass("CategoryList__Filter--current");

    var item = $(".CategoryListBlock");
    $(item).addClass("-visible");
    
    var selectedCategory = $(this).data("category");
    console.log(selectedCategory);
    
    $(item).removeClass("-visible");
    setTimeout(function(){
      $(item).each(function(){
        var category = $(this).data("category");
        if (category == selectedCategory) {
          $(this).addClass("-visible");
        } else {
          $(this).removeClass("-visible");
        }
      });
    },100);
  });

//ページ開いた時にSOTOのカテゴリーのみを表示する
$(document).ready(function(){
  var selectedCategory = $(".CategoryList__Filter--current").data("category");
  
  setTimeout(function(){
    $(".CategoryListBlock").each(function(){
      var category = $(this).data("category");
      if (category == selectedCategory) {
        $(this).addClass("-visible");
      } else {
        $(this).removeClass("-visible");
      }
    });
  },100); 
});


//フッターSPの開閉リンク
const myApp = {}
myApp.accordion = function () {
  if ($(".js-accordion").length) {

    $(".js-accordion").each(function () {      
      var parent = $(this);      
      parent.find(".js-accordion-toggle").on("click", function () {
        var button = $(this);
        if (parent.hasClass("is-active")) {
          button.removeClass("is-active");
          parent.removeClass("is-active");
          parent.find(".js-accordion-target").slideUp(300);
        } else {
          button.addClass("is-active");
          parent.addClass("is-active");
          parent.find(".js-accordion-target").slideDown(300);
        }
        return false;
      });
    });
  }
};
myApp.accordion()

//商品一覧の絞り込み
$(document).on("click", ".CollectionMenu__List--Link span.plus",function () {
    $(this).toggleClass("active");
    $(this)
      .parent("div")
      .next("ul")
      .slideToggle(400);
    return false;
  });



//商品詳細 関連商品カルーセル
$('.js-carousel').slick({
  arrows: true,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight:true,
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        arrows: false 
      }
    },
    {
      breakpoint: 1008,
      settings: {
        arrows: false,
        slidesToShow: 3.35,
        slidesToScroll: 3.35
      }
    },
    {
      breakpoint: 640,
      settings: {
        arrows: false,
        slidesToShow: 1.6,
        slidesToScroll: 1.6
      }
    }
  ]
});

/*スクロールバー*/
// window.onload = function () {
//   new Vue({
//     el: "#customScroll",
//     data: function () {
//       return {
//         scrollNow: false, // スクロール実行中フラグ
//         timer: false,
//       };
//     },
//     mounted: function () {
//       document
//         .querySelector(".block")
//         .addEventListener("scroll", this.handleScroll);
//     },
//     methods: {
//       /**
//        * スクロールイベント
//        */
//       handleScroll: function () {
//         this.scrollNow = true; // スクロールバーを表示
//         _this = this;

//         // 2秒後にスクロールバーを非表示
//         if (this.timer != false) clearTimeout(this.timer);
//         this.timer = setTimeout(function () {
//           _this.scrollNow = false;
//         }, 2000);
//       },
//     },
//   });
// };

// yotpoレビュー調整
window.addEventListener('DOMContentLoaded',()=> {
  setTimeout(()=> {
    const reviewHeader = document.querySelector('.yotpo-headline');
    if(reviewHeader) reviewHeader.innerText = "お客様の声はこちら";
  },1000);
});

//
function flickitySlider() {
    if (window.matchMedia('(max-width:1007px)').matches) {
      new Flickity('.Product__SlideshowNavScroller', {
        asNavFor: '.Product__Slideshow',
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });
  }
}

window.addEventListener('load', flickitySlider);
window.addEventListener('resize', flickitySlider);